import React from 'react';

export const Coconut = () => (
  <svg
    className="animate-pulse"
    fill="none"
    height="17"
    viewBox="0 0 32 17"
    width="32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m17.516 4.7263c-3.8282 3.8616-9.9219 2.1611-11.891 1.4761-0.20912-0.07084-0.39505 0.14764-0.29627 0.3484 0.38921 0.79712 1.185 2.1552 2.2423 3.1826 2.2132 2.2851 5.2398 3.5546 8.4174 3.5546h0.0349c6.4888 0 11.787-5.2788 11.909-11.88 0-0.12985-0.093-0.24205-0.2207-0.25387-1.1212-0.13582-6.1867-0.45468-10.195 3.5723z"
      fill="black"
      fillOpacity="0.9"
    />
    <path
      d="m30.556 0c-0.4416 0-0.8017 0.36606-0.7959 0.82075v0.17712c0 7.7174-6.1518 13.97-13.744 13.97-7.5925 0-13.744-6.259-13.744-13.97v-0.17712c0.00578-0.44878-0.35437-0.82075-0.79589-0.82075-0.43566 0-0.79002 0.36016-0.79583 0.80894v0.18894c0 8.609 6.8664 15.588 15.336 15.588 8.4696 0 15.336-6.9792 15.336-15.588v-0.18894c-0.0058-0.44878-0.3602-0.80894-0.7958-0.80894z"
      fill="black"
      fillOpacity="0.9"
    />
  </svg>
);

export const CalendarIcon = () => {
  return (
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m27.611 32.2c-1.0111 0-1.8657-0.3504-2.5639-1.0513-0.6981-0.7008-1.0472-1.5587-1.0472-2.5737s0.3491-1.8729 1.0472-2.5738c0.6982-0.7008 1.5528-1.0512 2.5639-1.0512s1.8658 0.3504 2.5639 1.0512c0.6981 0.7009 1.0472 1.5588 1.0472 2.5738s-0.3491 1.8729-1.0472 2.5737c-0.6981 0.7009-1.5528 1.0513-2.5639 1.0513zm-13.722 5.8c-0.7945 0-1.4745-0.284-2.0403-0.8519-0.5657-0.5679-0.8486-1.2506-0.8486-2.0481v-20.3c0-0.7975 0.2829-1.4802 0.8486-2.0481 0.5658-0.5679 1.2458-0.8519 2.0403-0.8519h1.4444v-2.9h2.8889v2.9h11.556v-2.9h2.8889v2.9h1.4444c0.7945 0 1.4745 0.284 2.0403 0.8519 0.5657 0.5679 0.8486 1.2506 0.8486 2.0481v20.3c0 0.7975-0.2829 1.4802-0.8486 2.0481-0.5658 0.5679-1.2458 0.8519-2.0403 0.8519h-20.222zm0-2.9h20.222v-14.5h-20.222v14.5zm0-17.4h20.222v-2.9h-20.222v2.9z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CheckInIcon = () => {
  return (
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m10.75 37.239v-4.6269c0-0.9088 0.2331-1.7626 0.6993-2.5612 0.4662-0.7987 1.1106-1.4046 1.9333-1.8177 1.3985-0.7161 2.9753-1.322 4.7304-1.8177 1.755-0.4957 3.6883-0.7436 5.7999-0.7436 0.8226 0 1.6247 0.0413 2.4063 0.1239 0.7815 0.0827 1.5425 0.2066 2.2829 0.3718l-2.8794 2.8918c-0.3016-0.0551-0.5964-0.0826-0.8843-0.0826h-0.9255c-1.947 0-3.6952 0.2341-5.2446 0.7023s-2.8177 0.9777-3.8049 1.5285c-0.2468 0.1377-0.4456 0.3305-0.5964 0.5783-0.1509 0.2479-0.2263 0.5233-0.2263 0.8262v1.322h10.284l3.2907 3.3049h-16.865zm22.295 0.661-5.6765-5.701 2.3035-2.3134 3.373 3.3875 8.309-8.3448 2.3035 2.3134-10.612 10.658zm-9.1317-13.88c-1.8099 0-3.3593-0.6472-4.6482-1.9417-1.2888-1.2944-1.9333-2.8504-1.9333-4.6681s0.6445-3.3737 1.9333-4.6681c1.2889-1.2944 2.8383-1.9417 4.6482-1.9417 1.8098 0 3.3592 0.6473 4.6481 1.9417s1.9333 2.8504 1.9333 4.6681-0.6444 3.3737-1.9333 4.6681c-1.2889 1.2945-2.8383 1.9417-4.6481 1.9417zm0-3.3049c0.9049 0 1.6796-0.3236 2.324-0.9708 0.6445-0.6472 0.9667-1.4253 0.9667-2.3341s-0.3222-1.6869-0.9667-2.3341c-0.6444-0.6472-1.4191-0.9708-2.324-0.9708-0.905 0-1.6797 0.3236-2.3241 0.9708s-0.9667 1.4253-0.9667 2.3341 0.3223 1.6869 0.9667 2.3341 1.4191 0.9708 2.3241 0.9708z"
        fill="currentColor"
      />
    </svg>
  );
};

export const WalkInIcon = () => {
  return (
    <svg
      fill="none"
      height="48"
      viewBox="0 0 48 48"
      width="48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m38.618 27.3v-4.95h-4.9091v-3.3h4.9091v-4.95h3.2727v4.95h4.9091v3.3h-4.9091v4.95h-3.2727zm-14.727-3.3c-1.8 0-3.3409-0.6462-4.6227-1.9387s-1.9227-2.8463-1.9227-4.6613 0.6409-3.3687 1.9227-4.6612 2.8227-1.9388 4.6227-1.9388 3.3409 0.6463 4.6227 1.9388c1.2819 1.2925 1.9228 2.8462 1.9228 4.6612s-0.6409 3.3688-1.9228 4.6613c-1.2818 1.2925-2.8227 1.9387-4.6227 1.9387zm-13.091 13.2v-4.62c0-0.935 0.2386-1.7943 0.7159-2.5781 0.4773-0.7837 1.1114-1.3819 1.9023-1.7944 1.6909-0.8525 3.4091-1.4918 5.1545-1.9181 1.7455-0.4262 3.5182-0.6394 5.3182-0.6394s3.5727 0.2132 5.3182 0.6394c1.7454 0.4263 3.4636 1.0656 5.1545 1.9181 0.7909 0.4125 1.425 1.0107 1.9023 1.7944 0.4773 0.7838 0.7159 1.6431 0.7159 2.5781v4.62h-26.182zm3.2727-3.3h19.636v-1.32c0-0.3025-0.075-0.5775-0.225-0.825s-0.3477-0.44-0.5932-0.5775c-1.4727-0.7425-2.9591-1.2993-4.4591-1.6706-1.5-0.3712-3.0136-0.5569-4.5409-0.5569s-3.0409 0.1857-4.5409 0.5569c-1.5 0.3713-2.9864 0.9281-4.4591 1.6706-0.2454 0.1375-0.4432 0.33-0.5932 0.5775s-0.225 0.5225-0.225 0.825v1.32zm9.8182-13.2c0.9 0 1.6705-0.3231 2.3114-0.9693 0.6409-0.6463 0.9613-1.4232 0.9613-2.3307s-0.3204-1.6843-0.9613-2.3306c-0.6409-0.6462-1.4114-0.9694-2.3114-0.9694s-1.6704 0.3232-2.3114 0.9694c-0.6409 0.6463-0.9613 1.4231-0.9613 2.3306s0.3204 1.6844 0.9613 2.3307c0.641 0.6462 1.4114 0.9693 2.3114 0.9693z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TapIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={className}
      fill="none"
      height="40"
      viewBox="0 0 40 40"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m18.407 39c-0.8619 0-1.67-0.181-2.4242-0.5429s-1.393-0.8746-1.9163-1.5381l-10.066-12.531 0.87734-0.9048c0.61569-0.6333 1.3545-1.0103 2.2165-1.1309 0.86195-0.1207 1.6623 0.0452 2.4012 0.4976l3.417 2.0357v-14.838c0-0.51268 0.177-0.94244 0.531-1.2893 0.354-0.34682 0.7927-0.52024 1.316-0.52024s0.9697 0.17342 1.3391 0.52024c0.3694 0.34683 0.5541 0.77659 0.5541 1.2893v21.352l-4.479-2.7143 4.8023 6.0167c0.1847 0.2111 0.4002 0.377 0.6464 0.4976 0.2463 0.1206 0.508 0.181 0.785 0.181h10.205c1.0159 0 1.8856-0.3544 2.609-1.0631 0.7234-0.7088 1.0851-1.5608 1.0851-2.556v-7.2381c0-0.5127-0.177-0.9425-0.531-1.2893s-0.7927-0.5202-1.316-0.5202h-10.113v-3.6191h10.113c1.5392 0 2.8475 0.5278 3.9249 1.5834 1.0775 1.0555 1.6162 2.3373 1.6162 3.8452v7.2381c0 1.9905-0.7234 3.6944-2.1703 5.1119-1.4468 1.4175-3.1861 2.1262-5.2179 2.1262h-10.205zm-11.636-24.429c-0.40019-0.6635-0.70803-1.3797-0.92352-2.1488-0.21549-0.769-0.32323-1.5607-0.32323-2.375 0-2.5032 0.90043-4.6369 2.7013-6.4012 1.8009-1.7643 3.9788-2.6464 6.5339-2.6464s4.7331 0.88214 6.5339 2.6464c1.8009 1.7643 2.7013 3.898 2.7013 6.4012 0 0.8143-0.1077 1.606-0.3232 2.375-0.2155 0.7691-0.5233 1.4853-0.9235 2.1488l-3.1862-1.8095c0.2463-0.4222 0.431-0.852 0.5541-1.2893 0.1232-0.4373 0.1847-0.9123 0.1847-1.425 0-1.5079-0.5387-2.7897-1.6161-3.8452-1.0775-1.0556-2.3858-1.5833-3.925-1.5833s-2.8475 0.52777-3.9249 1.5833c-1.0775 1.0556-1.6162 2.3373-1.6162 3.8452 0 0.5127 0.06157 0.9877 0.18471 1.425 0.12313 0.4373 0.30784 0.8671 0.55411 1.2893l-3.1862 1.8095z"
        fill="currentColor"
      />
    </svg>
  );
};
